import React from 'react';
import './Loading.css';

interface LoadingProps {
  message?: string;
  subtitle?: string;
}

/**
 * Loading component that displays a centered loading spinner with text
 * Follows the application's design system with dark background and accent colors
 */
const Loading: React.FC<LoadingProps> = ({ 
  message = 'Loading', 
  subtitle = 'wait a moment...' 
}) => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <div className="loading-text">{message}</div>
        {subtitle && (
          <div className="loading-subtitle" style={{ 
            color: '#B2B2B2', 
            fontSize: '0.875rem',
            marginTop: '0.5rem',
            textAlign: 'center'
          }}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default Loading;
